import { render, staticRenderFns } from "./FormReportName.vue?vue&type=template&id=f06b4242"
import script from "./FormReportName.vue?vue&type=script&lang=js"
export * from "./FormReportName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports